import React from 'react';
// import dataSourceArrow from '../../../../assets/data-source-arrow.svg';
// import dataSourceArrowDisabled from '../../../../assets/data-source-arrow-disabled.svg';
import styles from './DataSource.module.scss';
import LoadingSpinner from '../../../../common/_custom/LoadingSpinner/LoadingSpinner';
import clsx from 'clsx';
import { infoIconGreen, infoIconYellow, purpleRedirectIcon } from '../../../../assets/hostedassets';
import GstConnectionPopup from '../../DashboardModules/RevenueTables/GSTConnectionPopup/GstConnectionPopup';
import { GST_STATUS } from '../../../../store/investor/constants';
import Tooltip from '../../../../common/_custom/Tooltip/Tooltip';
import FileViewerDrawer from '../../../../common/DocumentViewer/FileViewerDrawer';
import { useGstAnalysisReport } from './useGstAnalysisReport';

interface DataSourceProps {
    dataSource: Object;
    isLoading: boolean;
    selectedTab: string;
    isPDFReport?: boolean;
    orgId?: string;
}

function DataSource({ dataSource, isLoading, selectedTab, isPDFReport = false, orgId }: DataSourceProps) {
    const keys = Object.keys(dataSource || {});
    const gstList = dataSource?.[1]?.gstList || [];
    const connectedGSTs = gstList.filter((gst) => gst?.connected);
    const isGstTab = ['revenue', 'vendorExpenses']?.includes(selectedTab);

    const { generatingReport, reportDoc, showFile, fileUrl, fileMimeType, downloadingFile, openReport, closeReport, downloadReport } =
        useGstAnalysisReport();

    const isNotConnected = (value) => {
        return value?.[0] === '0';
    };

    const getGSTListForPopup = () => {
        const gstList = dataSource?.[1]?.gstList || [];
        return gstList?.map((gst) => {
            let connectionStatus: string;
            if (gst?.connected) {
                connectionStatus = 'Connected';
            } else if (gst?.gstStatus === GST_STATUS.EXPIRED) {
                connectionStatus = 'Disconnected';
            } else {
                connectionStatus = 'Not Connected';
            }
            return {
                gstin: gst?.gstNumber,
                connectionStatus,
                gstStatus: gst?.gstStatus,
            };
        });
    };

    const getTextForGst = () => {
        const connectedGSTCount = connectedGSTs?.length;
        const totalGSTCount = gstList?.length;
        return `${connectedGSTCount}/${totalGSTCount}`;
    };

    return (
        <div className={styles.DataSource}>
            {!!keys?.length && (
                <>
                    {isLoading ? (
                        <LoadingSpinner color="#c9c9c9" height="20px" />
                    ) : (
                        dataSource && (
                            <div
                                className={clsx(styles.Content, {
                                    [styles.Animate]: !isPDFReport,
                                })}
                            >
                                {isGstTab ? 'GST Connected:' : 'Data Source'}
                                {keys.map((key) => (
                                    <div
                                        key={key}
                                        className={clsx(styles.SingleSource, {
                                            // [styles.NotConnected]: isNotConnected(
                                            //     dataSource[key]?.text,
                                            // ),
                                            [styles.NotAvailable]: isGstTab && isNotConnected(dataSource[key]?.text),
                                        })}
                                    >
                                        {dataSource[key]?.text}
                                        &nbsp;
                                        {isGstTab && (
                                            <Tooltip
                                                content={<GstConnectionPopup gstList={getGSTListForPopup()} />}
                                                direction="top"
                                                style={{
                                                    left: '-200px',
                                                    top: '25px',
                                                }}
                                            >
                                                <img
                                                    src={!isNotConnected(dataSource[key]?.text) ? infoIconGreen : infoIconYellow}
                                                    alt={''}
                                                    height={'14px'}
                                                />
                                            </Tooltip>
                                        )}
                                    </div>
                                ))}
                                {isGstTab && !isPDFReport && orgId && (
                                    <button className={styles.ViewGstBtn} onClick={() => openReport(orgId)} disabled={generatingReport}>
                                        {generatingReport ? (
                                            <LoadingSpinner color={'#6021b3'} height={'14px'} style={{ margin: 0 }} />
                                        ) : (
                                            <img src={purpleRedirectIcon} alt="" height="20px" />
                                        )}
                                        <span>{generatingReport ? 'Generating...' : 'GST Analysis Report'}</span>
                                    </button>
                                )}
                            </div>
                        )
                    )}
                </>
            )}
            {showFile && (
                <FileViewerDrawer
                    heading={reportDoc?.name ?? 'GST Analysis Report'}
                    fileUrl={fileUrl}
                    mimeType={fileMimeType}
                    downloading={downloadingFile}
                    onDownload={downloadReport}
                    onClose={closeReport}
                />
            )}
        </div>
    );
}

export default DataSource;
